import axios from "axios"
import * as XLSX from 'xlsx';

import AiAgentService from "@/services/cis-aiagent.service";

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

const boldStyle = { font: { name: 'Consolas', bold: true } };
const floatNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0" };
const stringStyle = { font: { name: 'Consolas' } };
const indexNumStyle = { font: { name: 'Consolas' }, numFmt: "0" };
const intNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0" };
const intNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0;[Red]\\ \\▼#,##0;[Black]\\ \"-\"" };
const rateNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0%" };
const rateNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0%;[Red]\\ \\▼#,##0%;[Black]\\ \"-\"" };

const propDesc = [
  { 
    gubun : '단순 카테고리 탐색', 
    mean: '해당 카테고리의 대·중·소 분류 키워드나, 브랜드·라인브랜드·상품명 등을 단독으로 검색', 
    needs: '', 
    cdj: '카테고리 탐색', 
    note: ''
  },
  { 
    gubun : '추천/순위/종류',
    mean: '추천, 순위, 종류, 브랜드와 같이 여러 제품에 대한 정보를 얻기 위한 검색', 
    needs: '정보/비교', 
    cdj: '카테고리 탐색', 
    note: ''
  },
  { 
    gubun : '비교/후기', 
    mean: '타 브랜드와 비교, 제품간 비교, 사용후기 등과 관련된 검색', 
    needs: '정보/비교', 
    cdj: '카테고리 탐색', 
    note: ''
  },
  { 
    gubun : '등급',
    mean: '각종 등급(고급, 프리미엄, 1등급 등)과 관련된 키워드를 포함하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '신체 부위',
    mean: '신체부위(장기 포함), 신체 관련 증상(고혈압, 비염 등)을 명시하는 키워드를 포함하는 검색', 
    needs: '대상/상황', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '단점/부작용',
    mean: '단점이나 부작용, 불만사항 등 위험 요소와 관련된 키워드를 포함하는 검색', 
    needs: '위험/신뢰', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '인물/광고',
    mean: '특정 인물 또는 광고, 광고 모델과 관련된 키워드를 포함하는 검색', 
    needs: '', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '기간',
    mean: '사용이나 가입 기간과 관련된 키워드를 포함하는 검색', 
    needs: '경제/조건', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '국가',
    mean: '제조국·수입국 등 나라를 명시하는 검색 (차량 분류에서 생산국을 한 나라로 지목한 것은 생산국)', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '지역',
    mean: '도 및 시·군·구 등 특정 지역을 명시하는 키워드를 포함하는 검색', 
    needs: '대상/상황', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '성별',
    mean: '성별을 명시하는 키워드를 포함하는 검색', 
    needs: '대상/상황', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '연령대',
    mean: '연령을 명시하는 키워드를 포함하는 검색', 
    needs: '대상/상황', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '대상',
    mean: '사용 주체 또는 사용 목적이 되는 대상(생명체)과 관련된 키워드를 포함하는 검색', 
    needs: '대상/상황', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '기능',
    mean: '핵심 동작 및 기술적 속성과 관련된 키워드를 포함하는 검색', 
    needs: '기능/용도', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '색상',
    mean: '색상을 명시하는 키워드를 포함하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '디자인',
    mean: '추상적인 디자인 관련 키워드를 포함하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '소재/원료',
    mean: '재질, 성분과 같이 소재나 원료와 관련된 키워드를 포함하는 검색 (패션의 충전재 종류는 충전재)', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '맛',
    mean: '단맛·매운맛처럼 어떤 맛인지를 지목하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '형태',
    mean: '외형(벽걸이, 타워형 등) 및 제형(고체, 액체, 분말, 캡슐 등)과 관련된 키워드를 포함하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '용량/크기',
    mean: '용량(평형, 개수 등), 크기, 길이, 패키징과 관련된 키워드를 포함하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '두께/무게',
    mean: '얇기 및 두께, 가벼움과 무거움, 각종 무게와 관련된 키워드를 포함하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '공간/장소',
    mean: '물리적으로 존재하는 장소와 관련된 키워드를 포함하는 검색', 
    needs: '대상/상황', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '용도/목적',
    mean: '추상적 개념으로써의 용도 및 목적과 관련된 키워드를 포함하는 검색', 
    needs: '기능/용도', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '생산/가공',
    mean: '가공, 추출, 정제 등 생산 방식과 관련된 키워드를 포함하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: ''
  },
  { 
    gubun : '차량 종류',
    mean: '차량 종류(SUV, 승용차, 트럭 등)에 대한 키워드를 포함하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: '금융트렌드, 자동차보험 카테고리 전용'
  },
  { 
    gubun : '계약 내용',
    mean: '특정 계약 내용에 대한 키워드를 포함하는 검색', 
    needs: '경제/조건', 
    cdj: '속성 탐색', 
    note: '금융트렌드, 자동차보험 카테고리 전용'
  },
  { 
    gubun : '금리',             
    mean: '이자율이 얼마이고 어떤 조건에서 달라지는지 따지는 검색', 
    needs: '경제/조건', 
    cdj: '속성 탐색', 
    note: '금융 관련 카테고리 전용'
  },
  { 
    gubun : '담보',             
    mean: '무엇을 담보로 잡는지, 담보가 있어야 하는지 따지는 검색', 
    needs: '경제/조건', 
    cdj: '속성 탐색', 
    note: '금융 관련 카테고리 전용'
  },
  { 
    gubun : '먹거리',           
    mean: '그곳에서 무엇을 먹을지 찾는 검색', 
    needs: '기능/용도', 
    cdj: '속성 탐색', 
    note: '호텔/리조트 등 여행 관련 카테고리 전용'
  },
  { 
    gubun : '볼거리',           
    mean: '그곳에서 무엇을 볼지 찾는 검색', 
    needs: '기능/용도', 
    cdj: '속성 탐색', 
    note: '호텔/리조트 등 여행 관련 카테고리 전용'
  },
  { 
    gubun : '놀거리',           
    mean: '그곳에서 무엇을 하며 놀지 찾는 검색', 
    needs: '기능/용도', 
    cdj: '속성 탐색', 
    note: '호텔/리조트 등 여행 관련 카테고리 전용'
  },
  { 
    gubun : '숙박',             
    mean: '어디서 묵을지, 어떤 숙소인지 찾는 검색', 
    needs: '기능/용도', 
    cdj: '속성 탐색', 
    note: '호텔/리조트 등 여행 관련 카테고리 전용'
  },
  { 
    gubun : '교통수단',          
    mean: '어떻게 오가는지(차·기차·셔틀) 찾는 검색', 
    needs: '기능/용도', 
    cdj: '속성 탐색', 
    note: '호텔/리조트 등 여행 관련 카테고리 전용'
  },
  { 
    gubun : '시트/크림',         
    mean: '먹는 것의 시트 또는 크림과 관련된 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: '케이크 전용'},
  { 
    gubun : '토핑',             
    mean: '위에 무엇을 얹는지 지목하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: '케이크 전용'
  },
  { 
    gubun : '생산국',           
    mean: '차량을 만든 나라를 한 나라로 지목하는 검색 (해외·유럽·북미처럼 여러 나라를 묶는 말은 국가)', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: '승용차, 전기차, 중고차 등 차량 관련 카테고리 전용'
  },
  { 
    gubun : '연식',             
    mean: '차량의 연식과 관련된 키워드를 포함하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: '승용차, 전기차, 중고차 등 차량 관련 카테고리 전용'
  },
  { 
    gubun : '겉감',             
    mean: '겉면에 쓰인 원단을 지목하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: '패딩, SPA패션 등 패션 관련 카테고리 전용'
  },
  { 
    gubun : '충전재',           
    mean: '오리털·거위털·웰론처럼 충전재의 종류를 지목하는 검색 (친환경·유기농 같은 성질은 소재/원료)', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: '패딩, SPA패션 등 패션 관련 카테고리 전용'
  },
  { 
    gubun : '기장',             
    mean: '옷 길이(롱·미디·숏)를 지목하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: '패딩, SPA패션 등 패션 관련 카테고리 전용'
  },
  { 
    gubun : '핏',               
    mean: '몸에 붙는 정도(오버핏·슬림핏)를 지목하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: '패딩, SPA패션 등 패션 관련 카테고리 전용'
  },
  { 
    gubun : '패턴/프린트',        
    mean: '무늬·프린트가 어떤 것인지 지목하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: '패딩, SPA패션 등 패션 관련 카테고리 전용'
  },
  { 
    gubun : '넥라인',            
    mean: '목선 모양(라운드·브이넥)을 지목하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: '패딩, SPA패션 등 패션 관련 카테고리 전용'
  },
  { 
    gubun : '디테일/부자재',      
    mean: '패션의 디테일 또는 부자재와 관련된 키워드를 포함하는 검색', 
    needs: '사양', 
    cdj: '속성 탐색', 
    note: '패딩, SPA패션 등 패션 관련 카테고리 전용'
  },
  { 
    gubun : '가격 및 구매처 탐색', 
    mean: '어디서 얼마에 살 수 있는지 값·비용·혜택을 따지는 검색', 
    needs: '경제/조건', 
    cdj: '구매 및 관리', 
    note: ''
  },
  { 
    gubun : '구매 후 관리',       
    mean: '이미 쓰기 시작한 뒤 사용법·문의·해지처럼 유지에 필요한 것을 찾는 검색', 
    needs: '관리', 
    cdj: '구매 및 관리', 
    note: ''
  }
]

export default class ExpXlInsight {
  constructor() {
    XLSX = require("xlsx-js-style");
  }

  newSheet4CDJ(columns, data) {
    var tmp_sheet = [];

    // Header
    var header_list = ['No.', 'CDJ'].concat(columns)
    var tmp_header = [];

    for (const col_nm of header_list) {
      tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
    };

    tmp_sheet.push(tmp_header);

    // Data
    for (const idx in data) { 
      var tmp_row = [];

      tmp_row.push({ v: Number(idx) + 1, t: "n", s: indexNumStyle });   // No.
      tmp_row.push({ v: data[idx].cdj, t: "s", s: stringStyle });       // CDJ

      for (const sub_item of data[idx].freq)
        tmp_row.push({t: "n", v: Number(sub_item), s: floatNumStyle});    // 검색량

      tmp_sheet.push(tmp_row)
    }
    
    var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
    // ws['!cols'] = this.autoFit(tmp_sheet)

    return ws;
  }

  newSheet4BrandShare(columns, data) {
    var tmp_sheet = [];

    // Header
    var header_list = ['No.', '브랜드'].concat(columns)
    var tmp_header = [];

    for (const col_nm of header_list) {
      tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
    };

    tmp_sheet.push(tmp_header);

    // Data
    for (const idx in data) {         
      var tmp_row = [];

      tmp_row.push({t: "n", v: Number(idx) + 1, s: indexNumStyle});       // No.
      tmp_row.push({t: "s", v: data[idx].keyword, s: stringStyle});       // 브랜드
      
      for (const sub_item of data[idx].freq)
        tmp_row.push({t: "n", v: Number(sub_item), s: floatNumStyle});    // 검색량

      tmp_sheet.push(tmp_row)
    }
    
    var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
    // ws['!cols'] = this.autoFit(tmp_sheet)

    return ws;
  }

  newSheet4StackedInsight(columns, data) {
    var tmp_sheet = [];

    // Header
    var header_list = ['No.', '브랜드', 'CDJ', '구분', '속성'].concat(columns)
    var tmp_header = [];

    for (const col_nm of header_list) {
      tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
    };

    tmp_sheet.push(tmp_header);

    // Data
    for (const idx in data) { 
      var tmp_row = [];

      tmp_row.push({ v: Number(idx) + 1, t: "n", s: indexNumStyle });       // No.
      tmp_row.push({ v: data[idx].brand, t: "s", s: stringStyle });         // 브랜드
      tmp_row.push({ v: data[idx].cdj, t: "s", s: stringStyle });           // CDJ
      tmp_row.push({ v: data[idx].cdj_details, t: "s", s: stringStyle });   // 구분
      tmp_row.push({ v: data[idx].prop, t: "s", s: stringStyle });          // 속성

      for (const sub_item of data[idx].freq)
        tmp_row.push({t: "n", v: Number(sub_item), s: floatNumStyle});      // 검색량

      tmp_sheet.push(tmp_row)
    }
    
    var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
    // ws['!cols'] = this.autoFit(tmp_sheet)

    return ws;
  }

  newSheet4TopRankKeywords(columns, data) {
    var tmp_sheet = [];

    // Header
    var header_list = ['No.', '키워드', '브랜드', 'TAG'].concat(columns)
    var tmp_header = [];

    for (const col_nm of header_list) {
      tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
    };

    tmp_sheet.push(tmp_header);

    // Data
    for (const idx in data) {         
      var tmp_row = [];

      tmp_row.push({t: "n", v: Number(idx) + 1, s: indexNumStyle});   // No.
      tmp_row.push({t: "s", v: data[idx].keyword, s: stringStyle});   // 키워드
      tmp_row.push({t: "s", v: data[idx].brand, s: stringStyle});     // 브랜드 
      tmp_row.push({t: "s", v: data[idx].prop, s: stringStyle});      // TAG 

      for (const sub_item of data[idx].freq)
        tmp_row.push({t: "n", v: Number(sub_item), s: floatNumStyle});    // 검색량

      tmp_sheet.push(tmp_row)
    }
    
    var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
    // ws['!cols'] = this.autoFit(tmp_sheet)

    return ws;
  }

  newSheet4PropDescription() {
    var tmp_sheet = [];

    // Header
    var header_list = ['No.', '구분', '뜻', '니즈 축', 'CDJ(참고)', '비고']
    var tmp_header = [];

    for (const col_nm of header_list) {
      tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
    };

    tmp_sheet.push(tmp_header);

    // Data
    for (const idx in propDesc) {         
      var tmp_row = [];

      tmp_row.push({t: "n", v: Number(idx) + 1, s: indexNumStyle}); // No.
      tmp_row.push({t: "s", v: propDesc[idx].gubun, s: stringStyle});   // 구분
      tmp_row.push({t: "s", v: propDesc[idx].mean, s: stringStyle});    // 뜻 
      tmp_row.push({t: "s", v: propDesc[idx].needs, s: stringStyle});   // 니즈 축 
      tmp_row.push({t: "s", v: propDesc[idx].cdj, s: stringStyle});     // CDJ(참고)
      tmp_row.push({t: "s", v: propDesc[idx].note, s: stringStyle});    // 비고

      tmp_sheet.push(tmp_row)
    }
    
    var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
    // ws['!cols'] = this.autoFit(tmp_sheet)

    return ws;
  }

  async xlExport(cat_id, st_dt, en_dt, dataset, target_dir = "") {
    if (dataset.length == 0) 
      return ""

    const workbook = XLSX.utils.book_new()	// 엑셀 생성

    // 속성 그룹 사전_전체 시트 추가
    XLSX.utils.book_append_sheet(workbook, this.newSheet4PropDescription(), "속성 그룹 사전_전체")

    for (const sheet of dataset) {
      const sheet_nm = sheet.sheet_nm.replace(/[\/]/g, '').trim().substring(0, 31)

      switch (sheet.sheet_type) {
        case 0:
            XLSX.utils.book_append_sheet(workbook, this.newSheet4CDJ(sheet.cat, sheet.data), sheet_nm)
            break
        case 1:
            XLSX.utils.book_append_sheet(workbook, this.newSheet4BrandShare(sheet.cat, sheet.data), sheet_nm)
            break
        case 2:
            XLSX.utils.book_append_sheet(workbook, this.newSheet4StackedInsight(sheet.cat, sheet.data), sheet_nm)
            break
        case 3:
            XLSX.utils.book_append_sheet(workbook, this.newSheet4TopRankKeywords(sheet.cat, sheet.data), sheet_nm)
            break
      }
    }

    // 엑셀 → ArrayBuffer 변환
    const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Blob으로 변환 후 FormData에 담아 전송
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const file_nm = 'insight_' + cat_id + '_' + st_dt + '_' + en_dt + '.xlsx'

    const formData = new FormData();
    formData.append('file', blob, file_nm);
    formData.append('filename', file_nm); // 저장 경로 전달
    formData.append('target_dir', target_dir);

    const response = await AiAgentService.callAiAgent_SaveExcel(formData, source)

    if(response && response.status == 200)
      return response.data.data.path
      // return response.data.path // for local test
    else
      return ""
  }

  async fileExist(cat_id, st_dt, en_dt, target_dir = "") {
    const file_nm = 'insight_' + cat_id + '_' + st_dt + '_' + en_dt + '.xlsx'

    const formData = new FormData();
    formData.append('filename', file_nm); // 저장 경로 전달
    formData.append('target_dir', target_dir);

    const response = await AiAgentService.callAiAgent_FileExist(formData, source)

    if(response && response.status == 200)
      return response.data.data.exist
      // return response.data.exist // for local test
    else
      return false
  }
}